var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAcStarFrRgbHor = function SvgAcStarFrRgbHor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0.6 809.8 163.1 14.7",
    enableBackground: "new 0.6 809.8 163.1 14.7",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M5.3,815.5h0.7v4.5H5.5v-3.9h0l-2,3.9H3l-2-3.9h0v3.9H0.6v-4.5h0.7l2,3.9L5.3,815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M7.3,815.5h3.6v0.4H7.8v1.5h3v0.4h-3v1.7H11v0.4H7.3V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.8,815.5h0.7v4.5H17v-3.9h0l-2,3.9h-0.4l-2-3.9h0v3.9h-0.5v-4.5h0.7l2,3.9L16.8,815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.2,815.9h2c0.5,0,0.9,0.2,0.9,0.7c0,0.6-0.4,0.8-1,0.8h-1.8V815.9z M18.8,820h2.5c0.7,0,1.5-0.3,1.5-1.3 c0-0.6-0.4-1-0.9-1.1v0c0.5-0.1,0.8-0.5,0.8-1c0-0.6-0.4-1.1-1.3-1.1h-2.6V820z M19.2,817.8h2.1c0.5,0,0.9,0.2,0.9,0.8 c0,0.6-0.5,0.9-1.1,0.9h-2V817.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.5,815.9h2c0.4,0,0.9,0.1,0.9,0.8c0,0.7-0.5,0.9-1,0.9h-2V815.9z M24,820h0.5v-2h1.8 c0.8,0,1.1,0.3,1.1,1.1c0,0.5,0,0.8,0.1,0.9H28c-0.1-0.1-0.1-0.6-0.2-0.9c0-0.7-0.2-1.1-0.8-1.2v0c0.6-0.1,0.9-0.6,0.9-1.1 c0-0.9-0.7-1.2-1.5-1.2H24V820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.2,815.5h3.6v0.4h-3.1v1.5h3v0.4h-3v1.7h3.2v0.4h-3.6V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.7,815.9h1.7c1,0,1.5,0.6,1.5,1.8c0,1.4-0.7,1.8-1.5,1.8h-1.7V815.9z M36.2,820h2.3c1.3,0,1.9-1,1.9-2.2 c0-1.4-0.7-2.2-2-2.2h-2.2V820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.7,818.2c0,0.8-0.2,1.8-2,1.8s-2-1-2-1.8v-2.8h0.5v2.8c0,1.2,0.8,1.4,1.5,1.4c0.8,0,1.5-0.2,1.5-1.4 v-2.8h0.5V818.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.8,815.9h2c0.4,0,0.9,0.1,0.9,0.8c0,0.7-0.5,0.9-1,0.9h-2V815.9z M49.4,820h0.5v-2h1.8 c0.8,0,1.1,0.3,1.1,1.1c0,0.5,0,0.8,0.1,0.9h0.5c-0.1-0.1-0.1-0.6-0.2-0.9c0-0.7-0.2-1.1-0.8-1.2v0c0.6-0.1,0.9-0.6,0.9-1.1 c0-0.9-0.7-1.2-1.5-1.2h-2.4V820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.5,814.3h0.6l-0.9,0.9h-0.4L56.5,814.3z M54.6,815.5h3.6v0.4H55v1.5h3v0.4h-3v1.7h3.2v0.4h-3.6V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.4,816.7c-0.1-0.8-0.7-1-1.4-1c-0.7,0-1.3,0.3-1.3,0.8c0,0.6,0.5,0.7,1.6,0.9c0.8,0.1,1.6,0.3,1.6,1.2 c0,1.1-1,1.4-1.9,1.4c-1.1,0-2-0.4-2-1.6h0.5c0.1,0.9,0.7,1.2,1.6,1.2c0.7,0,1.4-0.2,1.4-0.9c0-0.7-0.8-0.8-1.6-0.9 c-1.1-0.2-1.6-0.5-1.6-1.2c0-1,0.9-1.3,1.8-1.3c0.9,0,1.8,0.3,1.9,1.4H62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.1,815.5h3.6v0.4h-3.1v1.5h3v0.4h-3v1.7h3.2v0.4h-3.6V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.7,818.2h-2l1-2.2L71.7,818.2z M72.5,820H73l-2-4.5h-0.5l-2,4.5h0.5l0.6-1.4h2.4L72.5,820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M77.9,818.2c0,0.8-0.2,1.8-2,1.8c-1.8,0-2-1-2-1.8v-2.8h0.5v2.8c0,1.2,0.8,1.4,1.5,1.4 c0.8,0,1.5-0.2,1.5-1.4v-2.8h0.5V818.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M84.6,816.7c-0.1-0.8-0.7-1-1.4-1c-0.7,0-1.3,0.3-1.3,0.8c0,0.6,0.5,0.7,1.6,0.9c0.8,0.1,1.6,0.3,1.6,1.2 c0,1.1-1,1.4-1.9,1.4c-1.1,0-2-0.4-2-1.6h0.5c0.1,0.9,0.7,1.2,1.6,1.2c0.7,0,1.4-0.2,1.4-0.9c0-0.7-0.8-0.8-1.6-0.9 c-1.1-0.2-1.6-0.5-1.6-1.2c0-1,0.9-1.3,1.8-1.3c0.9,0,1.8,0.3,1.9,1.4H84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.6,815.9h-1.8v-0.4h4v0.4h-1.8v4.1h-0.5V815.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.4,818.2h-2l1-2.2L93.4,818.2z M94.2,820h0.5l-2-4.5h-0.5l-2,4.5h0.5l0.6-1.4h2.4L94.2,820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.1,815.9h2c0.4,0,0.9,0.1,0.9,0.8c0,0.7-0.5,0.9-1,0.9h-2V815.9z M95.7,820h0.5v-2h1.8 c0.8,0,1.1,0.3,1.1,1.1c0,0.5,0,0.8,0.1,0.9h0.5c-0.1-0.1-0.1-0.6-0.2-0.9c0-0.7-0.2-1.1-0.8-1.2v0c0.6-0.1,0.9-0.6,0.9-1.1 c0-0.9-0.7-1.2-1.5-1.2h-2.4V820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.9,818.2h-2l1-2.2L105.9,818.2z M106.7,820h0.5l-2-4.5h-0.5l-2,4.5h0.5l0.6-1.4h2.4L106.7,820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.1,815.5h0.5v4.1h2.8v0.4h-3.3V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.3,815.5h0.5v4.1h2.8v0.4h-3.3V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M116.6,815.5h0.5v4.5h-0.5V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.3,818.2h-2l1-2.2L121.3,818.2z M122.1,820h0.5l-2-4.5h-0.5l-2,4.5h0.5l0.6-1.4h2.4L122.1,820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.6,815.5h0.6l3.1,3.8h0v-3.8h0.5v4.5h-0.5l-3.2-3.8h0v3.8h-0.5V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.5,818.2c-0.1,1-0.9,1.8-2.2,1.8c-1.5,0-2.4-0.9-2.4-2.4c0-1,0.6-2.4,2.4-2.4c1,0,2,0.4,2.2,1.6H133 c-0.1-0.9-0.9-1.2-1.7-1.2c-1.1,0-1.9,0.6-1.9,1.9c0,1,0.5,1.9,1.9,1.9c1.1,0,1.6-0.5,1.8-1.4H133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.8,815.5h3.6v0.4h-3.1v1.5h3v0.4h-3v1.7h3.2v0.4h-3.6V815.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M147.9,813.9c0.5-0.8,1.1-1.5,1.8-2.2c0.7-0.7,1.4-1.3,2.1-1.9l-0.8,3.1L147.9,813.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M153.4,815.3c-0.9-0.1-1.8-0.3-2.8-0.5c-0.9-0.2-1.8-0.5-2.7-0.9l3.1-0.9L153.4,815.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M151.8,809.9c0.4,0.8,0.7,1.7,1,2.6s0.5,1.8,0.6,2.8l-2.3-2.3L151.8,809.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M146.8,820.4c-0.5-0.7-1-1.5-1.5-2.4c-0.4-0.8-0.8-1.7-1.1-2.6l2.8,1.7L146.8,820.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M149.8,815.7c-0.4,0.8-0.8,1.7-1.3,2.5c-0.5,0.8-1.1,1.6-1.7,2.3l0.1-3.2L149.8,815.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M144.2,815.5c0.9-0.1,1.9-0.1,2.8-0.1c1,0,1.9,0.1,2.8,0.3l-2.9,1.5L144.2,815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M152.6,823.5c-0.9,0.3-1.8,0.5-2.7,0.7c-0.9,0.2-1.9,0.3-2.8,0.3l2.5-2.1L152.6,823.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M149,819.2c0.7,0.6,1.3,1.3,2,2c0.6,0.7,1.2,1.5,1.7,2.3l-3-1.1L149,819.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M147.1,824.4c0.2-0.9,0.4-1.8,0.8-2.7c0.3-0.9,0.7-1.8,1.2-2.6l0.6,3.2L147.1,824.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M157.3,818.9c0,0.9-0.1,1.9-0.2,2.8c-0.1,0.9-0.3,1.9-0.6,2.8l-1.2-3L157.3,818.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M152.1,821c0.8-0.5,1.6-0.9,2.5-1.2c0.9-0.4,1.8-0.6,2.7-0.9l-2,2.6L152.1,821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M156.6,824.4c-0.8-0.5-1.6-1-2.3-1.6c-0.8-0.6-1.5-1.2-2.1-1.9l3.2,0.5L156.6,824.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M154.4,813c0.9,0.3,1.8,0.6,2.6,1c0.9,0.4,1.7,0.9,2.4,1.4l-3.2,0.2L154.4,813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M154.8,818.6c-0.2-0.9-0.3-1.8-0.4-2.8s-0.1-1.9,0-2.8l1.8,2.7L154.8,818.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M159.5,815.5c-0.7,0.6-1.4,1.2-2.2,1.7c-0.8,0.5-1.6,1-2.4,1.4l1.4-2.9L159.5,815.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161.9,815.1c0-0.2,0-0.5,0-0.7h0c-0.1,0.2-0.1,0.4-0.2,0.6l-0.3,0.8h-0.2l-0.3-0.8 c-0.1-0.2-0.1-0.4-0.2-0.6h0c0,0.2,0,0.5,0,0.7l0,0.7h-0.2l0.1-1.6h0.3l0.3,0.8c0.1,0.2,0.1,0.4,0.2,0.5h0c0-0.2,0.1-0.3,0.2-0.5 l0.3-0.8h0.3l0.1,1.6h-0.2L161.9,815.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M163.6,815.8c-0.1,0-0.2,0.1-0.4,0.1c-0.4,0-0.8-0.3-0.8-0.8c0-0.5,0.3-0.8,0.8-0.8c0.2,0,0.3,0,0.4,0.1 l0,0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.4,0-0.6,0.2-0.6,0.7c0,0.4,0.2,0.6,0.6,0.6c0.1,0,0.3,0,0.3-0.1L163.6,815.8z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAcStarFrRgbHor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ac_star_fr_rgb_hor.d516922846bbbc4dc89e3cc7f93187d3.svg";